import api from './client'
import { pricingTemplateApi } from './pricingTemplates'
import type { AssignableUser, MccOption, SalesRep } from '../api'

export const salesRepApi = {
  list: async (): Promise<SalesRep[]> => {
    const response = await api.get<SalesRep[]>('/reference/sales-reps')
    return response.data
  },
}

export const assignableUsersApi = {
  list: async (): Promise<AssignableUser[]> => {
    const response = await api.get<AssignableUser[]>('/reference/assignable-users')
    return response.data
  },
}

export const mccOptionApi = {
  list: async (): Promise<MccOption[]> => {
    const response = await api.get<MccOption[]>('/mcc-options')
    return response.data
  },
}

export const referenceApi = {
  salesReps: salesRepApi.list,
  pricingTemplates: pricingTemplateApi.list,
  assignableUsers: assignableUsersApi.list,
  mccOptions: mccOptionApi.list,
}
